"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Selectbox =
/*#__PURE__*/
function (_Component) {
  _inherits(Selectbox, _Component);

  function Selectbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Selectbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Selectbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      boxTop: 0,
      boxLeft: 0,
      boxWidth: 0,
      boxHeight: 0,
      isBoxSelecting: false
    });

    _defineProperty(_assertThisInitialized(_this), "getRef", function () {
      return _this.selectbox;
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectboxRef", function (c) {
      return _this.selectbox = c;
    });

    return _this;
  }

  _createClass(Selectbox, [{
    key: "render",
    value: function render() {
      var boxStyle = {
        left: this.state.boxLeft,
        top: this.state.boxTop,
        width: this.state.boxWidth,
        height: this.state.boxHeight,
        zIndex: 9000,
        position: this.props.fixedPosition ? 'fixed' : 'absolute',
        cursor: 'default'
      };
      return _react["default"].createElement("div", null, this.state.isBoxSelecting && _react["default"].createElement("div", {
        ref: this.getSelectboxRef,
        style: boxStyle,
        className: this.props.className
      }));
    }
  }]);

  return Selectbox;
}(_react.Component);

_defineProperty(Selectbox, "propTypes", {
  fixedPosition: _propTypes.bool,
  className: _propTypes.string
});

_defineProperty(Selectbox, "defaultProps", {
  className: 'selectable-selectbox'
});

var _default = Selectbox;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-selectable-fast-forked/lib/Selectbox.js
// module id = 1892
// module chunks = 0